<template>
  <div class="bol-list">
    <div class="e-form">
      <BolFilter :filter="filter" @search="searchBols"></BolFilter>
    </div>
    <BolTable
      ref="table"
      :items="items"
      :start="false"
      @loadMore="loadMore"
    ></BolTable>
  </div>
</template>
<script>
import BolFilter from "@/default/pages/bols/filter.vue";
import BolTable from "@/default/pages/bols/table.vue";

export default {
  name: "BolList",
  components: {
    BolFilter,
    BolTable,
  },
  data() {
    return {
      filter: {
        undelivered: true,
      },
      infinite: {
        page: 1,
        loading: false,
        last: false,
      },
      items: [],
    };
  },
  mounted() {
    window.BolList = {
      syncItem: this.syncItem,
    };
  },
  created() {
    this.loadBols();
  },
  methods: {
    searchBols() {
      this.$refs.table.scrollTop();
      this.infinite.page = 1;
      this.items = [];
      this.loadBols();
    },
    loadBols() {
      this.infinite.loading = true;
      const q = Object.assign({}, this.filter);
      if (q.status_eq == 4) delete q.undelivered;
      this.$http
        .get("/api/v1/bols", {
          params: { q, page: this.infinite.page },
        })
        .then((response) => {
          this.infinite.loading = false;
          const data = response.data;
          if (data.bols.length > 0) {
            this.items = this._.concat(this.items, data.bols);
          } else {
            this.infinite.last = true;
          }
        })
        .catch((err) => {
          this.infinite.loading = false;
          this.$message({ message: err.response.data.errors, type: "error" });
        });
    },
    loadMore() {
      if (!this.infinite.loading && !this.infinite.last) {
        this.infinite.page += 1;
        this.loadBols();
      }
    },
    syncItem(data, action) {
      let index = this.items.findIndex((obj) => obj.id == data.id);
      if (index >= 0) {
        action == "deleted"
          ? this.items.splice(index, 1)
          : this.items.splice(index, 1, data);
      } else {
        this.items.unshift({ ...data, new: true });
      }
    },
  },
};
</script>
